import LegalLayout from "@/pages/LegalLayout";

export default function Cookie() {
  return (
    <LegalLayout testId="cookie-page" title="Cookie Policy" updated="Dicembre 2025">
      <p>
        La presente Cookie Policy descrive i cookie e le tecnologie simili utilizzati dal sito
        <strong> socialwhale.it</strong> in conformità alle Linee Guida del Garante Privacy del
        10 giugno 2021 e al GDPR.
      </p>

      <h2>1. Cosa sono i cookie</h2>
      <p>
        I cookie sono piccoli file di testo che i siti web salvano sul dispositivo dell&apos;utente
        per consentire il corretto funzionamento e raccogliere informazioni sulla navigazione.
      </p>

      <h2>2. Categorie di cookie utilizzate</h2>
      <h3>Cookie tecnici (necessari)</h3>
      <p>
        Sono indispensabili per il funzionamento del sito (es. per mantenere la sessione sull&apos;area
        riservata). Non richiedono consenso.
      </p>
      <h3>Cookie analitici</h3>
      <p>
        Utilizzati per raccogliere statistiche aggregate e anonime sull&apos;uso del sito
        (pagine visitate, tempi di permanenza). Vengono attivati solo con il tuo consenso.
      </p>
      <h3>Cookie di terze parti</h3>
      <ul>
        <li><strong>Meta:</strong> quando visualizzi contenuti embed o clicchi verso i nostri profili social.</li>
        <li><strong>Google Fonts:</strong> caricamento dei font tipografici (Manrope, Syne).</li>
      </ul>

      <h2>3. Come gestire i cookie</h2>
      <p>
        Puoi accettare, rifiutare o modificare in ogni momento le tue preferenze tramite le
        impostazioni del browser. Di seguito le guide ufficiali:
      </p>
      <ul>
        <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">Google Chrome</a></li>
        <li><a href="https://support.mozilla.org/it/kb/Attivare%20e%20disattivare%20i%20cookie" target="_blank" rel="noopener noreferrer">Mozilla Firefox</a></li>
        <li><a href="https://support.apple.com/it-it/HT201265" target="_blank" rel="noopener noreferrer">Safari</a></li>
        <li><a href="https://support.microsoft.com/it-it/microsoft-edge" target="_blank" rel="noopener noreferrer">Microsoft Edge</a></li>
      </ul>

      <h2>4. Durata</h2>
      <p>
        I cookie tecnici hanno durata di sessione. I cookie analitici hanno durata fino a 13 mesi,
        in linea con le indicazioni del Garante.
      </p>

      <h2>5. Aggiornamenti</h2>
      <p>
        Questa policy può essere aggiornata per adeguarci a nuove tecnologie o normative.
        Consulta questa pagina periodicamente per restare informato.
      </p>

      <p className="mt-8 text-slate-400 text-sm">
        Per maggiori dettagli sul trattamento dei tuoi dati leggi la nostra{" "}
        <a href="/privacy">Privacy Policy</a>.
      </p>
    </LegalLayout>
  );
}
